import {
  TransactionType,
  TransactionTypeFilterOption,
  TransactionTypeStatus,
} from 'dashboard/models/transaction-type';
import Action from 'lib/interfaces/Action';

interface SetTransactionTypesPayload {
  transactionTypes: TransactionType[];
}

export interface TransactionTypesFilterParams {
  omni?: string | null;
  status?: TransactionTypeStatus[];
}

interface SetFiltersPayload {
  filters: TransactionTypesFilterParams;
}

interface SetFiltersOptionsPayload {
  filterOptions: TransactionTypeFilterOption[];
}

export function setFilters(
  filters: TransactionTypesFilterParams,
): Action<TransactionTypesActionType.SetFilters, SetFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: TransactionTypesActionType.SetFilters,
  };
}

export type TransactionTypesActions =
  | Action<TransactionTypesActionType.SetTransactionTypes, SetTransactionTypesPayload>
  | Action<TransactionTypesActionType.SetFilters, SetFiltersPayload>
  | Action<TransactionTypesActionType.SetFilterOptions, SetFiltersOptionsPayload>;

export enum TransactionTypesActionType {
  SetTransactionTypes = 'transaction-types/SET_TRANSACTION_TYPES',
  SetFilters = 'transaction-types/SET_FILTERS',
  SetFilterOptions = 'transaction-types/SET_FILTER_OPTIONS',
}

export function setTransactionTypes(
  transactionTypes: SetTransactionTypesPayload['transactionTypes'],
): Action<TransactionTypesActionType.SetTransactionTypes, SetTransactionTypesPayload> {
  return {
    payload: {
      transactionTypes,
    },
    type: TransactionTypesActionType.SetTransactionTypes,
  };
}

export function setTransactionTypeFilterOptions(
  filterOptions: SetFiltersOptionsPayload['filterOptions'],
): Action<TransactionTypesActionType.SetFilterOptions, SetFiltersOptionsPayload> {
  return {
    payload: {
      filterOptions,
    },
    type: TransactionTypesActionType.SetFilterOptions,
  };
}
